export const state = {
    spinnerState: false
}

export const getters = {
    spinnerState: (state) => state.spinnerState
}

export const mutations = {
    toggleSpinner(state, data) {
        state.spinnerState = data
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/spinner.js